import { fSub, fAdd, fDate, fTime } from 'src/utils/format-time';

import { _mock } from './_mock';
import { _addressBooks } from './_others';

// ----------------------------------------------------------------------

export const INVOICE_STATUS_OPTIONS = [
  { value: 'paid', label: 'Paid' },
  { value: 'pending', label: 'Pending' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'draft', label: 'Draft' },
];

export const INVOICE_SERVICE_OPTIONS = [...Array(8)].map((_, index) => ({
  id: _mock.id(index),
  name: _mock.role(index),
  price: _mock.number.price(index),
}));

const ITEMS = [...Array(3)].map((__, index) => {
  const total = INVOICE_SERVICE_OPTIONS[index].price * _mock.number.nativeS(index);

  return {
    id: _mock.id(index),
    total,
    title: _mock.productName(index),
    description: _mock.sentence(index),
    price: INVOICE_SERVICE_OPTIONS[index].price,
    service: INVOICE_SERVICE_OPTIONS[index].name,
    quantity: _mock.number.nativeS(index),
  };
});

export const _invoices = [...Array(20)].map((_, index) => {
  return {
    id: `INV-${index + 1}`,
    invoiceType: `Type ${index + 1}`, // Simple mock data for Type
    nameAgenda: `${_addressBooks[index % _addressBooks.length].name} - Agenda ${index + 1}`, // Simple mock data for Name & Agenda
    owner: `Owner ${index + 1}`, // Simple mock data for Owner
    date: `2023-10-${(index % 30) + 1}`, // Simple mock date
    time: `10:${(index % 60).toString().padStart(2, '0')} AM`, // Simple mock time
    members: `Member ${index + 1}`, // Simple mock data for Members
    location: `Location ${index + 1}`, // Simple mock data for Location
    status: ['paid', 'pending', 'overdue', 'draft'][index % 4], // Cycle through statuses
    totalAmount: (index + 1) * 100, // Simple mock total amount
    invoiceNumber: `INV-199${index}`,
    invoiceFrom: _addressBooks[index % _addressBooks.length],
    invoiceTo: _addressBooks[(index + 1) % _addressBooks.length],
  };
});
